import React from "react";
import "../styles/views/login.css";
import LoginView from "./LoginView";

function EmbeddedLoginView(props) {
    return (
        <div className={"white_background"}>
            <LoginView
                {...props}
            />
        </div>
    );
}

export default EmbeddedLoginView;
